import React from "react";
import { Link } from "react-router-dom";
import {
  FaInstagram,
  FaDribbble,
  FaTwitter,
  FaYoutube,
  FaChevronUp,
  FaMapMarkerAlt,
  FaArrowRight,
  FaFacebook,
  FaWhatsapp,
  FaTelegramPlane,
} from "react-icons/fa";
import "./Footer.css";
import { FaMessage } from "react-icons/fa6";

const companyLinks = [
  { label: "Home", to: "/" },
  { label: "About Us", to: "/#about" },
  { label: "Courses", to: "/#courses" },
  { label: "Videos", to: "/#videos" },
];

const exploreLinks = [
  { label: "Why Choose Us", to: "/#why-us" },
  { label: "Gallery", to: "/#gallery" },
  { label: "FAQ", to: "/#faq" },
  { label: "Contact Us", to: "/#contact" },
];

const socialLinks = [
  {
    label: "Instagram",
    url: "https://www.instagram.com/lifetime_embroidery_designclas",
    Icon: FaInstagram,
  },
  {
    label: "FaceBook",
    url: "https://www.facebook.com/lifetimecreationdesign",
    Icon: FaFacebook,
  },
  {
    label: "Whats App",
    url: "https://api.whatsapp.com/send?phone=+919879196990&text=Hello%20LTC%2C%20I%20want%20to%20Join%20Your%20LTC%20whatsapp%20Group%20to%20get%20Daily%20New%20Design%20Updates.",
    Icon: FaWhatsapp,
  },
  {
    label: "YouTube",
    url: "https://www.youtube.com/@lifetimecreationltc9063/videos",
    Icon: FaYoutube,
  },
  {
    label: "Telegram",
    url: "https://t.me/EmbroideryDesignLTC",
    Icon: FaTelegramPlane,
  },
];

export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="ltc-footer-root">
      <div className="ltc-footer-container">
        <div className="ltc-footer-grid">
          {/* Brand */}
          <div className="ltc-footer-brand">
            <Link
              to="/"
              className="ltc-footer-logo"
              aria-label="LifeTime Embroidery Design Class Home"
            >
              <span className="ltc-footer-logo-frame">
                <img src="/logo.jpg" alt="" className="ltc-footer-logo-image" />
              </span>

              <span className="ltc-footer-brand-copy">
                <span className="ltc-footer-brand-title">
                  Life
                  <span className="ltc-footer-brand-accent">Time</span>
                </span>

                <span className="ltc-footer-brand-subtitle">
                  Embroidery Design Class
                </span>
              </span>
            </Link>

            <p className="ltc-footer-description">
              Build your embroidery design skills with practical learning,
              creative guidance, and industry-focused training.
            </p>

            <div className="ltc-footer-socials">
              {socialLinks.map(({ label, url, Icon }) => (
                <a
                  key={label}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="ltc-footer-social-link"
                  aria-label={label}
                >
                  <Icon aria-hidden="true" />
                </a>
              ))}
            </div>
          </div>

          {/* Quick links */}
          <nav className="ltc-footer-column" aria-label="Footer quick links">
            <h3 className="ltc-footer-heading">Quick Links</h3>

            <ul className="ltc-footer-link-list">
              {companyLinks.map((item) => (
                <li key={item.label} className="ltc-footer-link-item">
                  <Link to={item.to} className="ltc-footer-link">
                    <FaArrowRight aria-hidden="true" />
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          {/* Explore */}
          <nav className="ltc-footer-column" aria-label="Footer explore links">
            <h3 className="ltc-footer-heading">Explore</h3>

            <ul className="ltc-footer-link-list">
              {exploreLinks.map((item) => (
                <li key={item.label} className="ltc-footer-link-item">
                  <Link to={item.to} className="ltc-footer-link">
                    <FaArrowRight aria-hidden="true" />
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          {/* Address */}
          <div className="ltc-footer-column">
            <h3 className="ltc-footer-heading">Visit Our Institute</h3>

            <div className="ltc-footer-address">
              <span className="ltc-footer-address-icon">
                <FaMapMarkerAlt aria-hidden="true" />
              </span>

              <p className="ltc-footer-address-text">
                <strong>LifeTime Embroidery Design Class</strong>
                <span>
                  Shop-17, UP GR Floor, Ranuja Complex, <br />
                  Nr- Riddhi Siddhi School, Vallabhacharya Road, Ashvani Kumar
                </span>
                <span>Surat-395008 Gujarat, India</span>
                <strong>Call Us</strong>
                <span>+91 9879196990, +91 9909614445</span>
                <span>lifetime.embcourse@gmail.com</span>
              </p>
            </div>

            <a
              href="https://www.embroiderydesigncourse.com/contact-us"
              className="ltc-footer-inquiry"
            >
              Send Inquiry
              <FaArrowRight aria-hidden="true" />
            </a>
          </div>
        </div>

        <div className="ltc-footer-bottom">
          <p className="ltc-footer-copyright">
            © {new Date().getFullYear()} LifeTime Embroidery Design Class. All
            Rights Reserved.
          </p>

          <button
            type="button"
            className="ltc-footer-top"
            aria-label="Back to top"
            onClick={scrollToTop}
          >
            <FaChevronUp aria-hidden="true" />
          </button>
        </div>
      </div>
    </footer>
  );
}
